export enum FontType {
    A = 'A',
    B = 'B'
}